@if (cart$ | async; as cart) {
  @if (cart.entries && cart.entries.length > 0) {
    <h1 class="title">{{ 'addToCart.cart.reservationTitle' | transloco }}</h1>

    <boels-well>
      <boels-date-picker
        (datesSelected)="onDatesSelected($event, cart?.cutOffTimestamp)"
        (datesPassed)="onDatesPassed($event)"
        [startDate]="cart.startDate"
        [endDate]="cart.endDate"
        [cutOffTimestamp]="cart?.cutOffTimestamp"
        [isCart]="true"
      ></boels-date-picker>
      <button
        boelsButton
        variant="main"
        shape="pill"
        [alwaysShowActionIcon]="true"
        action="next"
        [routerLink]="'/checkout/customer-details'"
        [isDisabled]="!datesSelected || datesPassed || cutOffTimePassed"
      >
        {{ 'addToCart.cart.btnLabel' | transloco }}
      </button>
      @if (!datesSelected || datesPassed) {
        <div class="info-message">
          <span>
            <fa-icon [icon]="faExclamationCircle"></fa-icon>
            {{ 'addToCart.cart.datesSelectedValidationMessage' | transloco }}
          </span>
        </div>
      }
      @if (
        datesSelected &&
        cart.startDate &&
        isToday(cart.startDate) &&
        isCutOffTimePassed(cart.startDate, cart?.cutOffTimestamp)
      ) {
        <div class="info-message">
          <span>
            <fa-icon [icon]="faExclamationCircle"></fa-icon>
            {{
              'addToCart.cart.cutOffTimeValidationMessage'
                | transloco
                  : {
                      startDate: cart.startDate | date: 'dd-MM-yyyy',
                    }
            }}
          </span>
        </div>
      }
    </boels-well>

    <h2 class="cart-title">{{ 'addToCart.cart.cartTitle' | transloco }}</h2>

    <div class="entries-list">
      @if (componentData.data$ | async; as componentData) {
        @for (item of cart?.entries; track $index) {
          <boels-order-entry
            [orderEntry]="item"
            variant="readonly"
            [accessories]="item.accessories"
            (entryEditRequested)="openAddToCartModal(item, $event)"
            (deleteOrderEntry)="deleteOrderEntry(item, $event)"
          ></boels-order-entry>
        }
      }
    </div>
    <boels-usp [componentData]="cartUspNodes$"></boels-usp>
  }
}
